(() => {
  // Keep this alternate template when testing variants before assigning it to the product.
  const previewParams = new URLSearchParams(window.location.search);
  if (previewParams.get('view') === 'salomon-pulse-2') {
    customElements.whenDefined('product-info').then(() => {
      const info = document.querySelector('product-info:has(.sh-pulse-assets)');
      if (!info || info.shPulsePreview) return;
      info.shPulsePreview = true;
      const request = info.buildRequestUrlWithParams.bind(info);
      info.buildRequestUrlWithParams = (...args) => {
        const url = new URL(request(...args), window.location.origin);
        url.searchParams.set('view', 'salomon-pulse-2');
        return url.pathname + url.search;
      };
      const update = info.updateURL.bind(info);
      info.updateURL = (...args) => {
        update(...args);
        const url = new URL(window.location.href);
        url.searchParams.set('view', 'salomon-pulse-2');
        if (previewParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', previewParams.get('preview_theme_id'));
        window.history.replaceState(window.history.state, '', url.pathname + url.search);
      };
    });
  }
  if (!customElements.get('sh-pulse-explorer')) {
    customElements.define('sh-pulse-explorer', class extends HTMLElement {
      connectedCallback() {
        this.features = [...this.querySelectorAll('[data-pulse-feature]')];
        this.photos = [...this.querySelectorAll('[data-pulse-photo]')];
        this.mobileLayout = window.matchMedia('(max-width: 749px)');
        this.selectedFeature = this.features.find((item) => item.open)?.dataset.pulseFeature;
        this.showFeature = (current) => {
          this.selectedFeature = current.dataset.pulseFeature;
          // Keep mobile panels independent: collapsing a panel above the tap moves the page.
          if (!this.mobileLayout.matches) {
            this.features.forEach((item) => { if (item !== current) item.open = false; });
          }
          this.photos.forEach((photo) => { photo.hidden = photo.dataset.pulsePhoto !== this.selectedFeature; });
        };
        this.onToggle = (event) => {
          const current = event.target;
          if (!current.matches('[data-pulse-feature]') || !current.open) return;
          this.showFeature(current);
        };
        this.onLayoutChange = () => {
          if (this.mobileLayout.matches) return;
          const current = this.features.find((item) => item.open && item.dataset.pulseFeature === this.selectedFeature)
            || this.features.find((item) => item.open);
          if (current) this.showFeature(current);
        };
        this.addEventListener('toggle', this.onToggle, true);
        this.mobileLayout.addEventListener('change', this.onLayoutChange);
      }
      disconnectedCallback() {
        this.removeEventListener('toggle', this.onToggle, true);
        this.mobileLayout?.removeEventListener('change', this.onLayoutChange);
      }
    });
  }
})();
